var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RadarChart',{staticClass:"mandala-evaluations-radar-chart",attrs:{"labels":_vm.labels,"display-legend":_vm.displayLegend,"styles":_vm.styles,"datasets":_vm.chartData,"padding":_vm.padding,"width":400,"height":400,"device-pixel-ratio":_vm.devicePixelRatio}})
}
var staticRenderFns = []

export { render, staticRenderFns }